/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/stores/AppStore';
import { IPDFConfig } from '../../components/S3DocumentViewer';

export interface IS3ViewDetails {
  title: string;
  s3Object: { bucket: string; key: string };
  pdfConfig: IPDFConfig;
}

export interface Irun {
  workerId: string | null;
}

const initialState: Irun = {
  workerId: null
};

export const runSlice = createSlice({
  name: 'run',
  initialState,
  reducers: {
    setWorkerId: (state, action: PayloadAction<string | null>) => {
      state.workerId = action.payload;
    }
  }
});

export const { setWorkerId } = runSlice.actions;

export const runSelector = (state: RootState) => state.run;
export default runSlice.reducer;
